import React from 'react';
import { useRegisterSW } from 'virtual:pwa-register/react';

function ReloadPrompt() {
    const {
        offlineReady: [offlineReady, setOfflineReady],
        needRefresh: [needRefresh, setNeedRefresh],
        updateServiceWorker,
    } = useRegisterSW({
        onRegistered(r) {
            console.log('SW Registered: ' + r);
        },
        onRegisterError(error) {
            console.log('SW registration error', error);
        },
    });

    const close = () => {
        setOfflineReady(false);
        setNeedRefresh(false);
    };

    if (!offlineReady && !needRefresh) {
        console.log("ReloadPrompt: Nothing to show.");
        return null;
    }

    console.log("ReloadPrompt: Showing prompt!", { offlineReady, needRefresh });

    return (
        <div className="ReloadPrompt-container fixed bottom-0 right-0 p-4 m-4 bg-white border border-gray-200 rounded-lg shadow-lg z-[9999] flex flex-col gap-2 max-w-sm">
            <div className="flex flex-col gap-2">
                {offlineReady ? (
                    <span className="text-sm font-medium text-gray-800">
                        App pronto para trabalhar offline
                    </span>
                ) : (
                    <span className="text-sm font-medium text-gray-800">
                        Nova versão disponível, clique para recarregar.
                    </span>
                )}
            </div>
            <div className="flex gap-2 mt-2">
                {needRefresh && (
                    <button
                        className="px-3 py-1.5 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700 transition-colors"
                        onClick={() => updateServiceWorker(true)}
                    >
                        Recarregar
                    </button>
                )}
                <button
                    className="px-3 py-1.5 text-sm font-medium text-gray-600 bg-gray-100 rounded hover:bg-gray-200 transition-colors"
                    onClick={close}
                >
                    Fechar
                </button>
            </div>
        </div>
    );
}

export default ReloadPrompt;
